require('../bootstrap');

$(document).ready(function (e) {
    let ajax_header = {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
    };

    $('#staff-login-form').on('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const btn_submit = $('button[type=submit]');

        $(this).removeClass('was-validated');

        if ($(this)[0].checkValidity() == false) {
            $(this).addClass('was-validated');

        } else {
            let uemail = $('#username').val().trim(),
                upass = $('#password').val().trim(),
                utype = 'tax_payer',
                loader = $(this).find('.spinner-border'),
                req_msg = $(this).find('.alert');

            $.ajax({
                headers: ajax_header,
                url: 'staff/login',
                type: 'post',
                data: {'username': uemail, 'password': upass },
                beforeSend: function (bs) {
                    loader.removeClass('d-none');
                    req_msg.addClass('d-none');
                    btn_submit.prop('disabled', true);
                },
                complete: function() {
                    loader.addClass('d-none');
                    btn_submit.prop('disabled', false);

                },
                success: function (data) {
                    req_msg.removeClass('alert-danger d-none').addClass('alert-success').text(data.message);
                    
                    window.location.href = data.url;
                    
                },
                error: function (err) {
                    var err_msg;

                    switch (err['status']) {
                        case 429:
                        case 422:
                            let err_data = $.parseJSON(err.responseText);
                            
                            if (err_data.errors.email) {
                                err_msg = err_data.errors.email[0];
                                
                            } else {
                                err_msg = err_data.errors.password[0];
                                
                            }
                            break;
                            
                        case 403:
                            err_msg = err['responseJSON']['message'];
                            break;
                            
                        case 404:
                            err_msg = err.statusText;
                            break;

                        case 500:
                            err_msg = "Oops! There's something wrong.";
                            break;
                    }

                    req_msg.removeClass('alert-success d-none').addClass('alert-danger').text(err_msg);
                }
            });

        }

    });
    



    // Update Password
    const form_rule = new PasswordValidator(
        '#password',
        '#current_password',
        '#staff-password-rules'
    );

    $('#staff-update-pass-btn').on('click', function(e){
        if(form_rule.isValid() == false) {
            e.preventDefault();

        }
    });

    $('.unmask-pass').on('click', function () {
        var password = $(this).parent().prev();
        var icon = $(this).find('i');

        if (password.attr('type') === 'password') {
            password.attr('type', 'text');
            icon.removeClass('fa-eye').addClass('fa-eye-slash');
            $(this).attr('aria-label', 'Hide password');
        } else {
            password.attr('type', 'password');
            icon.removeClass('fa-eye-slash').addClass('fa-eye');
            $(this).attr('aria-label', 'Show password');
        }
    });
    
    
});


class PasswordValidator {
    constructor(passwordInput, oldPasswordInput, rulesContainer) {
        this.password = $(passwordInput);
        this.oldPassword = $(oldPasswordInput);
        this.rules = $(rulesContainer);

        this.password.on('input', () => this.validate());
        this.oldPassword.on('input', () => this.validate());
    }

    validate() {
        const password = this.password.val();
        const oldPassword = this.oldPassword.val();

        this.setRule('length', password.length >= 12);
        this.setRule('uppercase', /[A-Z]/.test(password));
        this.setRule('lowercase', /[a-z]/.test(password));
        this.setRule('number', /[0-9]/.test(password));
        this.setRule('special', /[^A-Za-z0-9]/.test(password));
        this.setRule(
            'different',
            password.length > 0 && password !== oldPassword
        );

        return this.isValid();
    }

    setRule(rule, valid) {
        const element = this.rules.find(`[id="${rule}"]`);

        element
            .toggleClass('text-black-50', false)
            .toggleClass('text-success', valid)
            .toggleClass('text-danger', !valid);


    }

    isValid() {
        const password = this.password.val();
        const oldPassword = this.oldPassword.val();

        return (
            password.length >= 12 &&
            /[A-Z]/.test(password) &&
            /[a-z]/.test(password) &&
            /[0-9]/.test(password) &&
            /[^A-Za-z0-9]/.test(password) &&
            password !== oldPassword
        );
    }
}


